<button
  (click)="onSectionClicked()"
  [attr.aria-current]="active() ? 'true' : null"
  [class.on-hover]="!active()"
  [class.active]="active()"
  class="section m-b-1"
  type="button"
>
  <p [class.primary]="active()" [class.text-weight-bold]="active()" class="no-pad">
    {{ title() | translate }}
  </p>
</button>
